// extracted by mini-css-extract-plugin
export var item = "MenuGroup-module--item--5036d";
export var menuColumn = "MenuGroup-module--menuColumn--061ac";
export var menuItems = "MenuGroup-module--menuItems--63ba7";